/**
 * Product data for virtual try-on
 * Each product can have multiple images that will be displayed with crossfade animation
 * and sent to Vertex AI for better try-on results
 */

export const PRODUCTS = [
  {
    id: "1",
    name: "MIST Wide Jeans",
    imagePaths: [
      "/images/example-products/1/1.jpg",
      "/images/example-products/1/2.jpg",
      "/images/example-products/1/3.jpg",
    ],
    size: "M",
    price: "$99.99",
    description: "Wide loose jeans with a modern design",
  },
  {
    id: "2",
    name: "Oxford Shirt",
    imagePaths: [
      "/images/example-products/2/1.jpg",
      "/images/example-products/2/2.jpg",
      "/images/example-products/2/3.jpg",
    ],
    size: "L",
    price: "$79.99",
    description: "Classic Oxford shirt with a modern fit",
  },
  {
    id: "3",
    name: "Upcycled Down Feather Jacket",
    imagePaths: [
      "/images/example-products/3/1.jpg",
      "/images/example-products/3/2.jpg",
      "/images/example-products/3/3.jpg",
    ],
    size: "M",
    price: "$289.99",
    description:
      "Light and warm down feather jacket made from upcycled materials",
  },
  {
    id: "4",
    name: "Henley Shirt",
    imagePaths: [
      "/images/example-products/4/1.jpg",
      "/images/example-products/4/2.jpg",
      "/images/example-products/4/3.jpg",
    ],
    size: "M",
    price: "$49.99",
    description:
      "A classic Henley shirt crafted from a rib-knitted cotton jersey. A long-sleeve style with a ribbed neck binding and a half placket with buttoning",
  },
];

export default PRODUCTS;
